/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import HeadPage from "pages/StepPages/StepFour/HeadPage";
import sass from "./pattern.module.sass";
import { Search } from "components-new";
import useDebounce from "hooks/useDebounce";
import { useLocation } from "react-router-dom";
import { usePagination } from "../../../hooks/usePagination";
import DropMenu from "../../StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import {directoryAPI} from "../../../libs/apiClient/Directory";

interface ITypeThreatPatternList {
	comment: string;
	id: number;
	name: string;
	organization: {
		fullName: string;
		id: number;
		shortName: string;
	};
}

const ThreatPattern = () => {
	const [params, setParams] = useState<{
		page: number;
		num: number;
		query: string;
	}>({
		page: 1,
		num: 35,
		query: "",
	});
	const endOf = useRef<HTMLTableRowElement | null>(null);
	const [data, setData] = useState<ITypeThreatPatternList[]>([]);
	const location = useLocation();

	const [search, setSearch] = useState("");

	const query = useDebounce(search, 400);

	useEffect(() => {
		setParams((prevState) => ({
			...prevState,
			page: 1,
			query,
		}));
	}, [query]);

	const [target, setTarget] = useState<HTMLDivElement | undefined>(undefined);

	const dropRef = useRef<HTMLDivElement | null>(null);

	const outlineStyle = useCallback(
		(id: number) => {
			return location.state && location.state.outline && location.state.outline === id ? sass.outline : "";
		},
		[location],
	);

	const thenHandler = (data: ITypeThreatPatternList[]) => {
		if (params.page === 1) {
			if (data.length) {
				if (data.length < params.num) {
					setIsFinally(true);
				} else {
					setParams((prevState) => ({ ...prevState, query, page: prevState.page + 1 }));
				}
			} else {
				setIsFinally(true);
			}
			setData(data);
		} else {
			if (data.length) {
				if (!(data.length < params.num)) {
					setParams((prevState) => ({ ...prevState, query, page: prevState.page + 1 }));
				} else {
					setIsFinally(true);
				}
				setData((prevState) => [...prevState, ...data]);
			} else {
				setIsFinally(true);
			}
		}
	};

	const { setIsFinally } = usePagination("/directory/threat-model-template/list", params, thenHandler, endOf);

	const toggleTarget = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};

	const removePattern = useCallback(() => {
		const id = Number(target?.dataset.id);
		if (id) {
			directoryAPI.threatModelTemplateDelete(+target?.dataset.id!).then(() => {
				setTarget(undefined);
				setData((prevState) => prevState.filter((_) => _.id !== id));
			});
		}
	}, [target]);

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (dropRef.current && target && !dropRef.current.contains(event.target)) {
				setTarget(undefined);
			}
		}

		document.addEventListener("mouseup", handleClickOutside);
		return () => {
			document.removeEventListener("mouseup", handleClickOutside);
		};
	}, [target]);

	return (
		<div className={sass.wrapper}>
			<DropMenu ref={dropRef} click={removePattern} target={target as HTMLOrSVGElement} />

			<HeadPage title={"Шаблоны модели угроз"}>
				<div className={sass.head}>
					<Search className={sass.search} searchValue={search} handleSearch={(e) => setSearch(e.target.value)} />
				</div>
			</HeadPage>
			<table>
				<thead>
					<tr>
						<th>Порядковый номер</th>
						<th>Название</th>
						<th>Организация</th>
						<th>Комментарий</th>
						<th />
					</tr>
				</thead>
			</table>
			<div data-comment-false={true} className={sass.scroll}>
				<table>
					<tbody>
						{data.map((_, index) => {
							return (
								<tr key={index} className={outlineStyle(_.id!)}>
									<td>{index + 1}</td>
									<td>{_.name}</td>
									<td>{_.organization.fullName}</td>
									<td>{_.comment}</td>
									<td>
										<div className={sass.dotted} data-id={_.id} onClick={toggleTarget}>
											<div className={sass.icon} />
										</div>
									</td>
								</tr>
							);
						})}
						<tr ref={endOf} />
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default ThreatPattern;
